import React, { useState, useEffect, useCallback } from "react";
import {
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Typography,
  Box,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Paper,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
  Snackbar,
  Alert,
  Link,
  CardHeader,
  CardContent,
} from "@mui/material";
import "date-fns";
import Select from "react-select";
import DateRangePicker from "react-daterange-picker";
import { extendMoment } from "moment-range";
import originalMoment from "moment";
import {
  CalendarMonth,
  DeleteSharp,
  EditSharp,
  Info,
  PendingActions,
} from "@mui/icons-material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../sidebar/sidebar";
import { companylogo } from "../../assets/images";
import {
  getAllExpensesDataAPI,
  getAllExpensesTypeAPI,
  addExpenseAPI,
  updateExpenseAPI,
  deleteExpenseAPI,
  addExpenseTypeAPI,
  getAllBankAccountsDataAPI,
  addBankAccountAPI,
} from "../../service/service";
import "./Expenses.scss";
import Axios from "axios";
import { BaseUrl } from "../../Environment";
import { getSecureItem } from "../../utilsFunctions";

const moment = extendMoment(originalMoment);
const optionsOfAccount = [{ label: "Cash", value: "0000" }];

const Expenses = () => {
  const history = useHistory();
  const loggedinUser = getSecureItem("loggedinUser");
  const userPermissions = getSecureItem("UsersAccess");

  const filterArrays = (apiArr, staticArr) => {
    // Combine both arrays
    const combinedArr = [...apiArr, ...staticArr];

    // Group by label
    const groupedByLabel = combinedArr.reduce((acc, current) => {
      acc[current.label] = acc[current.label] || [];
      acc[current.label].push(current);
      return acc;
    }, {});

    // Filter groups to only include API data if both API and static data are present
    const filteredArr = Object.values(groupedByLabel).reduce((acc, group) => {
      const hasApiData = group.some((item) => apiArr.includes(item));
      const apiGroup = group.filter((item) => apiArr.includes(item));
      const staticGroup = group.filter((item) => staticArr.includes(item));

      if (hasApiData) {
        // If API data is present, use only API data
        acc.push(...apiGroup);
      } else {
        // If no API data, use static data
        acc.push(...staticGroup);
      }

      return acc;
    }, []);

    return filteredArr;
  };

  const indirectCategories = [
    { label: "Travel & Accommodation", value: "S1" },
    { label: "Legal Fees/Dues", value: "S2" },
    { label: "Supplies & Maintenance", value: "S3" },
    { label: "Miscellaneous", value: "S4" },
  ];

  const directCategories = [
    { label: "Interest Paid on Debt", value: "S5" },
    { label: "Salaries and Benefits", value: "S6" },
    { label: "Courier/Postage", value: "S7" },
    { label: "Rent", value: "S8" },
    { label: "Utilities", value: "S9" },
    { label: "Equipment Buying & Leasing", value: "S10" },
    { label: "Depreciation", value: "S11" },
    { label: "Insurance", value: "S12" },
    { label: "Bank Charges", value: "S13" },
    { label: "Advertising and Promotion", value: "S14" },
  ];

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [toastMsg, setToastMsg] = useState({
    msg: "",
    time: 2000,
    variant: "success",
  });

  const [payload, setPayload] = useState({
    amount: "",
    note: "",
    transactionDate: moment().format("YYYY-MM-DD"),
  });

  const [errors, setErrors] = useState({
    expenseTypeId: null,
    amount: "",
    transactionDate: "",
    cAgentId: "",
  });

  const [bankAccountData, setBankAccountData] = useState([]);
  const [accountId, setAccountId] = useState("");
  const [labelOfBank, setLabelOfBank] = useState("");
  const [branchId, setBranchId] = useState('');
  const [branchData, setBranchData] = useState([]);
  const [totalAmt, setTotalAmt] = useState({});
  const [labelOfType, setLabelOfType] = useState("");
  const [file, setFile] = useState("");
  const [expenseId, setExpenseId] = useState(null);
  const [transactionId, setTransactionId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [expensesData, setExpensesData] = useState([]);
  const [expensesTypeData, setExpensesTypeData] = useState([]);
  const [directExpensesTypeData, setDirectExpensesTypeData] = useState([]);
  const [indirectExpensesTypeData, setIndirectExpensesTypeData] = useState([]);
  const [deleteExpenseModal, setDeleteExpenseModal] = useState(false);
  const [approveDeclineModal, setApproveDeclineModal] = useState(false);
  const [dateRangeModal, setDateRangeModal] = useState(false);
  const [addUpdateModal, setAddUpdateModal] = useState(false);
  const [dateRange, setDateRange] = useState();
  const [expenseTypeFilter, setExpenseTypeFilter] = useState(null);
  const [branchIdFilter, setBranchIdFilter] = useState(null);
  const [accountIdFilter, setAccountIdFilter] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);
  const [directIndirect, setDirectIndirect] = React.useState("Direct");
  const [cAgentId, setCAgentId] = useState("");
  const [cAgentData, setCAgentData] = useState([]);

  const fetchBAData = async () => {
    try {
      const resp = await getAllBankAccountsDataAPI({
        companyId: loggedinUser?.companyId,
        searchQuery: "",
      });

      if (resp?.data?.length > 0) {
        setBankAccountData(resp.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchBAData();
  }, []);

  const getFilteredAccounts = () => {
    const accountsSelectData = [
      ...bankAccountData.map((item) => ({
        label: item.bankName,
        value: item.accountId,
      })),
      ...optionsOfAccount,
    ];

    const uniqueAccounts = accountsSelectData.reduce((acc, item) => {
      if (
        !acc.has(item.label) ||
        (acc.has(item.label) && acc.get(item.label).value === "0000")
      ) {
        acc.set(item.label, item);
      }
      return acc;
    }, new Map());

    return Array.from(uniqueAccounts.values());
  };

  const handleAccountChange = (val) => {
    // if (val?.value === "0000") {
    //   setLabelOfBank(val?.label);
    //   setAccountId(val?.value);
    // } else {
      setLabelOfBank("");
      setAccountId(val?.value);
    // }
  };

  const resolveAccountId = async () => {
    const userId = loggedinUser?.userId;
    const companyId = loggedinUser?.companyId;

    if (labelOfBank) {
      const bankRes = await addBankAccountAPI({
        code: "0000",
        bankName: labelOfBank,
        companyId,
        createdByUserId: userId,
        updatedByUserId: userId,
      });

      if (bankRes?.status === 200) {
        const newAccountId = bankRes.data?.result?.accountId;
        setLabelOfBank("");
        setAccountId(newAccountId);
        fetchBAData();
        return newAccountId;
      }

      return accountId;
    }

    return accountId;
  };

  const filteredDataAccounts = getFilteredAccounts();

  const handleDirectIndirect = (event) => {
    setExpenseId(null);
    setCategoryId(null);
    setDirectIndirect(event.target.value);
  };

  const fetchExpensesData = async () => {
    try {
      const companyId = loggedinUser?.companyId;
      const userId = loggedinUser?.userId;
      const userType = loggedinUser?.userType;

      const expensesRes = await getAllExpensesDataAPI({
        companyId,
        userId: cAgentId || "",
        userType: "",
        expenseTypeFilter,
        accountIdFilter,
        branchIdFilter: loggedinUser?.userType == "superAdmin" ? branchIdFilter || null : branchIdFilter || loggedinUser?.branchId || null,
        startDateFilter: dateRange?.start
          ? dateRange.start.startOf("d").format("YYYY-MM-DD HH:mm:ss")
          : null,

        endDateFilter: dateRange?.end
          ? dateRange.end.endOf("d").format("YYYY-MM-DD HH:mm:ss")
          : null,
          withRelations: true,
          withTotals: true
      });

      if (expensesRes?.status == 200 && expensesRes?.data) {
        setExpensesData(expensesRes.data?.data);
        setTotalAmt(expensesRes.data?.totals);
      } else {
        setExpensesData([]);
        setTotalAmt({})
        setToastMsg({
          msg: "No data available.",
          time: 2000,
          variant: "error",
        });

        setTimeout(() => {
          handleOpen();
        }, 500);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchExpenseTypesData = async () => {
    try {
      const companyId = loggedinUser?.companyId;

      const expenseTypesRes = await getAllExpensesTypeAPI(companyId);

      if (expenseTypesRes?.status == 200 && expenseTypesRes.data?.data) {
        setExpensesTypeData(expenseTypesRes.data.data?.map((item) => ({
          label: item.title,
          value: item.categoryId,
        })));
        const apiDirectExpensesType = expenseTypesRes.data?.data
          ?.filter((data) => data?.type == "Direct")
          .map((item) => ({
            label: item.title,
            value: item.categoryId,
          }));

        const apiIndirectExpensesType = expenseTypesRes.data?.data
          ?.filter((data) => data?.type == "Indirect")
          .map((item) => ({
            label: item.title,
            value: item.categoryId,
          }));

        setDirectExpensesTypeData(
          filterArrays(apiDirectExpensesType, directCategories)
        );
        setIndirectExpensesTypeData(
          filterArrays(apiIndirectExpensesType, indirectCategories)
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllUsers = async () => {
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(`${BaseUrl}/user/getAllUsers?userName=&companyId=${companyId}&branchId=${loggedinUser?.branchId || ''}`, {
      headers,
    })
      .then((res) => {
        const Response = res.data?.result;
        const userData = loggedinUser?.userType === "Collection Agent" ? Response?.filter((item) => item?.userId == loggedinUser?.userId) : Response;

        const cList = userData?.map((item) => ({
          label: `${item.firstName} ${item.lastName}`,
          value: item?.userId,
        }));
        setCAgentData(cList);
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const { data } = await Axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser.companyId },
        headers,
      });

      const branchData = loggedinUser?.userType == "superAdmin" ? data?.data : data?.data?.filter((item) => item?.branchId == loggedinUser?.branchId);

      setBranchData(branchData?.map(item => ({
        label: item.branchName,
        value: item.branchId
      })) || []);
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  useEffect(() => {
    fetchBranches();
    getAllUsers();
  }, []);

  useEffect(() => {
    fetchExpensesData();
  }, [expenseTypeFilter, branchIdFilter, cAgentId, dateRange]); // Add dependencies as necessary

  useEffect(() => {
    fetchExpenseTypesData();
  }, [directIndirect]); // Add dependencies as necessary

  const handleChange = (key, value) => {
    setPayload((prev) => ({ ...prev, [key]: value }));
  };

  const handleSaveExpense = async () => {
    const userId = loggedinUser?.userId;
    const companyId = loggedinUser?.companyId;
    const { amount, note, transactionDate } = payload;

    const newErrors = {
      expenseTypeId: (categoryId ? !categoryId : !expenseId)
        ? "This field is required"
        : "",
      amount: !payload.amount ? "This field is required" : "",
      cAgentId: !cAgentId ? "This field is required" : "",
      transactionDate: !payload.transactionDate ? "This field is required" : "",
    };

    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error != "");

    if (!hasErrors) {
      try {
        let catePayload, cateRes;

        if (labelOfType) {
          catePayload = {
            title: labelOfType,
            description: `Desc ${directIndirect}`,
            type: directIndirect,
            color: "#0a2861",
            companyId,
            createdByUserId: userId,
            updatedByUserId: userId,
          };

          cateRes = await addExpenseTypeAPI(catePayload);

          if (cateRes?.status == 200) {
            setLabelOfType("");
          }
        }

        const resolvedAccountId = await resolveAccountId();

        let expensePayload = new FormData();
        expensePayload.append("amount", amount);
        if (branchId) {
          expensePayload.append("branchId", branchId);
        }
        if (resolvedAccountId) {
          expensePayload.append("accountId", resolvedAccountId);
        }
        expensePayload.append("note", note);
        expensePayload.append("transactionDate", transactionDate);
        expensePayload.append(
          "categoryId",
          cateRes?.data?.result?.categoryId
            ? cateRes?.data?.result?.categoryId
            : expenseId
            ? expenseId
            : categoryId
        );
        expensePayload.append("companyId", companyId);
        expensePayload.append("userId", cAgentId);
        expensePayload.append("createdByUserId", cAgentId);
        expensePayload.append("updatedByUserId", cAgentId);
        expensePayload.append("transactionStatus", loggedinUser?.userType == "superAdmin" ? 1 : 0);
        expensePayload.append("invoiceReceipt", file);
        if (isUpdate) {
          expensePayload.append("transactionId", transactionId);
        }

        const res = isUpdate
          ? await updateExpenseAPI(expensePayload)
          : await addExpenseAPI(expensePayload);

        if (res?.status == 200) {
          setCAgentId("");
          setAddUpdateModal(false);
          setToastMsg({
            msg: `Expense ${isUpdate ? "Updated" : "Added"} Successfully.`,
            time: 4000,
            variant: "success",
          });

          setTimeout(() => {
            handleOpen();
          }, 500);
          setTimeout(() => {
            fetchExpenseTypesData();
            // fetchBAData();
            fetchExpensesData();
          }, 1000);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleEdit = (data) => {
    setExpenseId(null);
    setPayload({
      amount: data.amount,
      note: data.note,
      transactionDate: moment(data.transactionDate).format("YYYY-MM-DD"),
    });
    setFile(data?.invoiceReceipt);
    setCategoryId(data?.categoryId);
    setTransactionId(data?.transactionId);
    setCAgentId(data?.user?.userId);
    setBranchId(data?.branchId);
    setAccountId(data?.accountId || "");
    setLabelOfBank("");
    setIsUpdate(true);
    setAddUpdateModal(true);
  };

  const handleDelete = async () => {
    try {
      await deleteExpenseAPI(transactionId);
      setDeleteExpenseModal(false);

      setToastMsg({
        msg: "Expense Deleted Successfully.",
        time: 3000,
        variant: "success",
      });

      setTimeout(() => {
        handleOpen();
      }, 500);

      setTimeout(() => {
        fetchExpensesData();
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdateStatus = useCallback(
    async transactionStatus => {
      try {
        const token = getSecureItem("token");

        const headers = {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        };

        const formDataToSend = new FormData();
        formDataToSend.append('transactionId', transactionId);
        formDataToSend.append('transactionStatus', transactionStatus);

        const response = await Axios.put(
          BaseUrl + `/transaction/putTransaction`,
          formDataToSend,
          {
            headers: headers,
          }
        );

        // console.log("handleUpdateStatus", response.data);

        if (response.data?.status) {
          setApproveDeclineModal(false);
          fetchExpensesData();
          alert(`Expense ${transactionStatus == 1 ? "Approved" : transactionStatus == 2 ?  "Declined" : "Updated"} successfully.`);
        } else {
          alert('Something went wrong.');
        }
      } catch (error) {
        console.log('handleUpdateStatus error:', error);
      }
    },
    [transactionId],
  );

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleKeyDown = (event) => {
    event.preventDefault(); // Block any keyboard interaction
  };

  /** ------------------- STATIC DATA WITH DYNAMIC VALUES ------------------- **/
  const summary = [
    {
      srNo: 3,
      label: 'Total Expense',
      value: (totalAmt?.unapproved != null && totalAmt?.approved != null)
      ? (Number(totalAmt?.unapproved) + Number(totalAmt?.approved))
      : 0,
      color: '#0F4C81',
    },
    {
      srNo: 0,
      label: 'Yet to Approve',
      value: totalAmt?.unapproved || 0,
      color: '#FF6F61',
    },
    {
      srNo: 2,
      label: 'Declined Amt',
      value: totalAmt?.declined || 0,
      color: '#BF1932',
    },
    {
      srNo: 1,
      label: 'Approved Amt',
      value: totalAmt?.approved || 0,
      color: '#009B77',
    },
  ];

  return (
    expensesTypeData && (
      <>
        <Sidebar />

        <Snackbar
          open={open}
          autoHideDuration={toastMsg.time}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={toastMsg.variant}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {toastMsg.msg}
          </Alert>
        </Snackbar>

        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          padding={"10px 100px"}
        >
          <img src={companylogo} alt="logo" />
        </Stack>

        <Stack
          className="expensespage"
          spacing={1}
          padding={"10px 20px 10px 100px"}
        >
          <Grid container>
            <Grid item md={6} sm={4}></Grid>
            <Grid item md={3} sm={4} sx={{ padding: "0 10px" }}>
              <Button
                className="muiCustomButton"
                variant="outlined"
                onClick={() => history.push("expensetypes")}
              >
                Manage Expense Types
              </Button>
            </Grid>
            {userPermissions?.Expenses && (
            <Grid item md={3} sm={4} sx={{ padding: "0 10px" }}>
              <Button
                className="GreenBTN"
                variant="filled"
                onClick={() => {
                  setPayload({
                    amount: "",
                    note: "",
                    transactionDate: moment().format("YYYY-MM-DD"),
                  });
                  setCAgentId("");
                  setCategoryId(null);
                  setExpenseId(null);
                  setAccountId(bankAccountData?.[bankAccountData?.length-1]?.accountId);
                  setLabelOfBank("");
                  setIsUpdate(false);
                  setAddUpdateModal(true);
                }}
              >
                + Add Expense
              </Button>
            </Grid>)}
          </Grid>

          <Box sx={{ width: "98%", padding: "10px", backgroundColor: "#fff" }}>
            <Typography
              variant="body2"
              marginBlock={1}
              fontSize={15}
              fontWeight={700}
            >
              Filter Expenses
            </Typography>
            <Grid container alignItems={"center"}>
              <Grid
                item
                md={3}
                xs={12}
                sx={{ padding: "0 10px", marginTop: "20px" }}
              >
                <Select
                  options={branchData}
                  placeholder="Select Branch"
                  value={
                    branchIdFilter &&
                    branchData.find((item) => item.value == branchIdFilter)
                  }
                  onChange={(val) => setBranchIdFilter(val?.value)}
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={12}
                sx={{ padding: "0 10px", marginTop: "20px" }}
              >
                <Select
                  options={expensesTypeData}
                  placeholder="Select Expense Types"
                  value={
                    expenseTypeFilter &&
                    expensesTypeData.find((item) => item.value == expenseTypeFilter)
                  }
                  onChange={(val) => setExpenseTypeFilter(val?.value)}
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={12}
                sx={{ padding: "0 10px", marginTop: "20px" }}
              >
                <Select
                  options={cAgentData}
                  placeholder="Select User"
                  value={
                    cAgentId &&
                    cAgentData?.find(
                      (item) => item.value == cAgentId
                    )
                  }
                  onChange={(val) => setCAgentId(val?.value)}
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={12}
                sx={{ padding: "0 10px", marginTop: "20px" }}
              >
                <Button
                  onClick={() => setDateRangeModal(true)}
                  variant="outlined"
                  fullWidth
                  startIcon={<CalendarMonth />}
                >
                  Select Date Range
                </Button>
              </Grid>
            </Grid>

            <Stack
              mt={2}
              mr={1}
              direction={"row"}
              alignSelf={"flex-end"}
              justifyContent={"flex-end"}
            >
              <Button
                className="muiCustomButton"
                onClick={() => {
                  setCAgentId("");
                  setAccountIdFilter("");
                  setBranchIdFilter(null);
                  setExpenseTypeFilter(null);
                  setDateRange();
                }}
                variant="outlined"
              >
                Reset
              </Button>
            </Stack>
          </Box>

          <Grid item container paddingY={2}>
              {summary?.map((data, i) => {
                return (
                  <Grid key={i} item xs={12} sm={6} md={4} lg={3} marginTop={2}>
                    <Card
                      elevation={3}
                      sx={{
                        marginRight: 5,
                        minHeight: 130,
                        borderRadius: 3,
                        backgroundColor: "#fff",
                      }}
                    >
                      <CardHeader
                        title={
                          <div style={{ fontSize: 15, color: data?.color }}>{data?.label}</div>
                        }
                      />
                      <CardContent>
                        <CardHeader
                          title={
                            <div style={{ fontSize: 20, color: data?.color }}>
                              {data?.value}
                            </div>
                          }
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>

          <Card style={{ marginTop: "10px" }}>
            <div className="tableLaylout">
              <Table aria-label="sticky table" className="table">
                <TableHead>
                  <TableRow className="tablHeadRowPayment">
                    <TableCell className="tablHeadCellPayment">Date</TableCell>
                    <TableCell className="tablHeadCellPayment">Type</TableCell>
                    <TableCell className="tablHeadCellPayment">
                      Amount
                    </TableCell>
                    {/* <TableCell className="tablHeadCellPayment">
                      Accounts
                    </TableCell> */}
                    <TableCell className="tablHeadCellPayment">
                      Description
                    </TableCell>
                    <TableCell className="tablHeadCellPayment">
                      Is Recurring
                    </TableCell>
                    <TableCell className="tablHeadCellPayment">
                      Recurring Type
                    </TableCell>
                    {userPermissions?.editExpenses && (
                    <TableCell className="tablHeadCellPayment">
                      Actions
                    </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {expensesData.map((data) => {
                    const {
                      transactionId,
                      amount,
                      note,
                      transactionDate,
                      categoryId,
                      transactionStatus,
                    } = data;

                    const selectedType = expensesTypeData.find(
                      (item) => item.value == categoryId
                    );

                    return (
                      <TableRow key={transactionId} className="tableRow">
                        <TableCell>
                          {originalMoment(transactionDate).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell>{selectedType?.label}</TableCell>
                        <TableCell>{amount}</TableCell>
                        {/* <TableCell>{selectedAccount?.bankName}</TableCell> */}
                        <TableCell>{note}</TableCell>
                        <TableCell>No</TableCell>
                        <TableCell>-</TableCell>
                        {userPermissions?.editExpenses && (<TableCell>
                          <Stack direction={"row"} spacing={1}>
                            {transactionStatus == 0 && <Tooltip title="Approve/Decline"><IconButton
                              color="success"
                              aria-label="approve"
                              onClick={() => {
                                setTransactionId(transactionId);
                                setApproveDeclineModal(true);
                              }}
                            >
                              <PendingActions />
                            </IconButton></Tooltip>}
                            <IconButton
                              color="primary"
                              aria-label="update"
                              onClick={() => handleEdit(data)}
                            >
                              <EditSharp />
                            </IconButton>
                            <IconButton
                              color="error"
                              aria-label="delete"
                              onClick={() => {
                                setTransactionId(transactionId);
                                setDeleteExpenseModal(true);
                              }}
                            >
                              <DeleteSharp />
                            </IconButton>
                          </Stack>
                        </TableCell>)}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          </Card>
        </Stack>

        {/* Delete Expense Modal */}
        <Dialog
          open={deleteExpenseModal}
          onClose={() => setDeleteExpenseModal(false)}
        >
          <DialogTitle>Delete Expense</DialogTitle>
          <DialogContent>
            <Typography fontSize={15} variant="h6">
              Are you sure, You want to delete this expense record?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Stack direction={"row"} spacing={2}>
              <Button
                variant="outlined"
                onClick={() => setDeleteExpenseModal(false)}
              >
                Cancel
              </Button>
              <Button color="error" variant="contained" onClick={handleDelete}>
                Delete
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>

        {/* Approve/Decline Expense Modal */}
        <Dialog
          open={approveDeclineModal}
          onClose={() => setApproveDeclineModal(false)}
        >
          <DialogTitle>Approve/Decline Expense</DialogTitle>
          <DialogContent>
            <Typography fontSize={15} variant="h6">
            Approve/Decline, this pending expense.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Stack direction={"row"} spacing={2}>
              <Button
                variant="outlined"
                onClick={() => handleUpdateStatus(2)}
              >
                Decline
              </Button>
              <Button color="success" variant="contained" onClick={() => handleUpdateStatus(1)}>
                Approve
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>

        {/* Date Range Modal */}
        <Dialog open={dateRangeModal} onClose={() => setDateRangeModal(false)}>
          <DialogTitle>Select Date</DialogTitle>
          <DialogContent>
            <DateRangePicker
              value={dateRange}
              onSelect={setDateRange}
              singleDateRange
            />
            <Stack spacing={1} marginTop={1}>
              <Typography fontSize={15} textAlign={"center"} variant="h6">
                Start Date:{" "}
                {dateRange?.start
                  ? dateRange.start.startOf("d").format("DD/MM/YYYY")
                  : "-"}
              </Typography>
              <Typography fontSize={15} textAlign={"center"} variant="h6">
                End Date:{" "}
                {dateRange?.end
                  ? dateRange.end.startOf("d").format("DD/MM/YYYY")
                  : "-"}
              </Typography>
            </Stack>
          </DialogContent>
        </Dialog>

        {/* Add/Update Modal */}
        <Dialog
          fullWidth
          maxWidth="sm"
          open={addUpdateModal}
          onClose={() => setAddUpdateModal(false)}
        >
          <DialogTitle>{isUpdate ? "Update" : "Add"} Expense</DialogTitle>
          <DialogContent>
            <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <Paper elevation={3} sx={{ p: 2, width: "100%" }}>
                <Stack spacing={0.5} marginBottom={1}>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                      Direct/Indirect Expense Types
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={directIndirect}
                      onChange={handleDirectIndirect}
                    >
                      <FormControlLabel
                        value="Direct"
                        control={<Radio />}
                        label="Direct"
                      />
                      <FormControlLabel
                        value="Indirect"
                        control={<Radio />}
                        label="Indirect"
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
                <Stack spacing={0.5} marginBottom={1}>
                  <Stack direction={"row"} spacing={2} alignItems={"center"}>
                    <Typography variant="body1">
                      Expense Type
                      <span style={{ color: "red", fontSize: 15 }}>*</span>
                    </Typography>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        history.push("expensetypes");
                      }}
                      style={{ fontSize: 12, cursor: "pointer" }}
                      underline="none"
                    >
                      {"Add/Update Expense Types"}
                    </Link>
                  </Stack>

                  <Select
                    options={
                      directIndirect == "Direct"
                        ? directExpensesTypeData
                        : indirectExpensesTypeData
                    }
                    value={
                      expenseId
                        ? expenseId &&
                          expensesTypeData.find((item) => item.value == expenseId)
                        : categoryId &&
                          expensesTypeData.find((item) => item.value == categoryId)
                    }
                    onChange={(item) => {
                      if (typeof item?.value != "string") {
                        setExpenseId(item?.value);
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          expenseTypeId: null,
                        }));
                      } else {
                        setLabelOfType(item?.label);
                        setExpenseId(item?.value);
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          expenseTypeId: null,
                        }));
                      }
                    }}
                    placeholder="Expense Type"
                  />
                  {errors.expenseTypeId && (
                    <Typography style={{ color: "red", fontSize: "12px" }}>
                      {errors.expenseTypeId}
                    </Typography>
                  )}
                </Stack>

                <Stack spacing={0.5} marginBottom={1}>
                  <Typography variant="body1">
                    Expense Amount
                    <span style={{ color: "red", fontSize: 15 }}>*</span>
                  </Typography>
                  <TextField
                    hiddenLabel
                    value={payload.amount}
                    inputMode="numeric"
                    type="number"
                    placeholder="Enter Expense Amount"
                    onChange={(e) => handleChange("amount", e.target.value)}
                    variant="outlined"
                    fullWidth
                  />
                  {errors.amount && (
                    <Typography style={{ color: "red", fontSize: "12px" }}>
                      {errors.amount}
                    </Typography>
                  )}
                </Stack>
                <Stack spacing={0.5} marginBottom={1}>
                  <Typography variant="body1">Link to User<span style={{ color: "red", fontSize: 15 }}>*</span></Typography>
                  <Select
                    options={cAgentData}
                    value={cAgentData.find((item) => item.value == cAgentId)}
                    onChange={(val) => setCAgentId(val?.value)}
                    placeholder="Link to User"
                  />
                  {errors.cAgentId && (
                    <Typography style={{ color: "red", fontSize: "12px" }}>
                      {errors.cAgentId}
                    </Typography>
                  )}
                </Stack>
                <Stack spacing={0.5} marginBottom={1}>
                  <Typography variant="body1">Link to Branch</Typography>
                  <Select
                    options={branchData}
                    isDisabled={( loggedinUser?.company?.planId == 3) ? false : true}
                    value={branchData.find((item) => item.value == branchId)}
                    onChange={(val) => setBranchId(val?.value)}
                    placeholder="Select Branch"
                  />
                </Stack>
                 <Stack spacing={0.5} marginBottom={1}>
                  <Typography variant="body1">Payment Mode</Typography>
                  <Select
                    options={filteredDataAccounts}
                    value={filteredDataAccounts.find((item) => item.value == accountId)}
                    onChange={handleAccountChange}
                    placeholder="Select Payment Mode"
                  />
                </Stack>
                <Stack spacing={0.5} marginBottom={1}>
                  <Typography variant="body1">
                    Expense Date
                    <span style={{ color: "red", fontSize: 15 }}>*</span>
                  </Typography>
                  <input
                    type="date"
                    onKeyDown={handleKeyDown} // Block typing
                    style={{
                      borderWidth: "1px",
                      borderColor: "lightgray",
                      borderRadius: "4px",
                      width: "95%",
                      padding: "10px",
                    }}
                    value={payload.transactionDate}
                    onChange={(e) =>
                      handleChange("transactionDate", e.target.value)
                    }
                  />
                  {errors.transactionDate && (
                    <Typography style={{ color: "red", fontSize: "12px" }}>
                      {errors.transactionDate}
                    </Typography>
                  )}
                </Stack>
                <Stack spacing={0.5} marginBottom={1}>
                  <Typography variant="body1">Invoice/Receipt</Typography>
                  <input
                    type="file"
                    accept="image/*,application/pdf"
                    style={{
                      border: "1px solid lightgray",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                    onChange={handleFileChange}
                  />
                  {typeof file == "string" && <span>{file}</span>}
                </Stack>
                <Stack spacing={0.5} marginBottom={1}>
                  <Typography variant="body1">Expense Description</Typography>
                  <TextField
                    hiddenLabel
                    value={payload.note}
                    placeholder="Enter Expense Description"
                    onChange={(e) => handleChange("note", e.target.value)}
                    variant="outlined"
                    fullWidth
                  />
                </Stack>
              </Paper>
            </Box>
          </DialogContent>
          <DialogActions>
            <Stack direction={"row"} spacing={2}>
              <Button
                variant="outlined"
                onClick={() => setAddUpdateModal(false)}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSaveExpense}>
                {isUpdate ? "Update" : "Add"}
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </>
    )
  );
};

export default Expenses;
